import { Dispatch } from 'redux';
import {
  SubscribeTypes,
  SUBSCRIBE_ERROR,
  SUBSCRIBE_SUCCESS,
  SUBSCRIBING,
  REPLACE_PAYMENT_METHOD_ERROR,
  REPLACE_PAYMENT_METHOD_SUCCESS,
  REPLACING_PAYMENT_METHOD,
  REGISTER_SUBSCRIBER_ERROR,
  REGISTER_SUBSCRIBER_SUCCESS,
  REGISTERING_SUBSCRIBER,
  FORCE_SUBSCRIPTION_PAYMENT_ERROR,
  FORCE_SUBSCRIPTION_PAYMENT_SUCCESS,
  FORCING_SUBSCRIPTION_PAYMENT,
  SubscriptionTypes,
} from '../config/ActionTypes';
import {
  subscribe,
  registerSubscriber,
  replacePaymentMethod,
  forceSubscriptionPayment,
} from '../../services/subscriber.service';
import { SubscribeRequest, SubscriberRequest } from '../../types/subscriber/request';
import { PlexoUrl, ReplacePaymentMethodPlexoUrl } from '../../types/instruments/response';
import { CustomErrorResponse } from '../../types/customError/response';
import { selectSubscriptionType } from './subscriptionTypes.actions';

const isPlexoUrl = (object: PlexoUrl | CustomErrorResponse): boolean => {
  return 'url' in object;
};

export const executeRegisterSubscriber = (subscriberRequest: SubscriberRequest) => {
  return (dispatch: Dispatch<SubscribeTypes | SubscriptionTypes>) => {
    dispatch(registeringSubscriber());

    return registerSubscriber(subscriberRequest).then(
      (response) => {
        if (isPlexoUrl(response)) {
          const instrumentResponse = response as PlexoUrl;
          dispatch(selectSubscriptionType(subscriberRequest.subscriptionTypeId));
          dispatch(registerSubscriberSuccess(instrumentResponse.url));
        }
      },
      (error) => {
        dispatch(registerSubscriberFailed(error));
      },
    );
  };
};

export const registeringSubscriber = (): SubscribeTypes => ({
  type: REGISTERING_SUBSCRIBER,
});

export const registerSubscriberSuccess = (plexoUrl: string): SubscribeTypes => ({
  type: REGISTER_SUBSCRIBER_SUCCESS,
  plexoUrl,
});

export const registerSubscriberFailed = (error: string): SubscribeTypes => ({
  type: REGISTER_SUBSCRIBER_ERROR,
  error,
});

export const executeSubscribe = (subscribeRequest: SubscribeRequest) => {
  return (dispatch: Dispatch<SubscribeTypes>) => {
    dispatch(subscribing());

    return subscribe(subscribeRequest).then(
      (response) => {
        dispatch(subscribeSuccess());
      },
      (error) => {
        dispatch(subscribeFailed(error));
      },
    );
  };
};

export const subscribing = (): SubscribeTypes => ({
  type: SUBSCRIBING,
});

export const subscribeSuccess = (): SubscribeTypes => ({
  type: SUBSCRIBE_SUCCESS,
});

export const subscribeFailed = (error: string): SubscribeTypes => ({
  type: SUBSCRIBE_ERROR,
  error,
});

const isReplacePaymentMethodPlexoUrl = (
  object: ReplacePaymentMethodPlexoUrl | CustomErrorResponse,
): boolean => {
  return 'instrument' in object;
};

export const executeReplacePaymentMethod = (userId: string | undefined) => {
  return (dispatch: Dispatch<SubscribeTypes>) => {
    dispatch(replacingPaymentMethod());

    return replacePaymentMethod(userId).then(
      (response) => {
        if (isReplacePaymentMethodPlexoUrl(response)) {
          const instrumentResponse = response as ReplacePaymentMethodPlexoUrl;
          dispatch(replacePaymentMethodSuccess(instrumentResponse.instrument.url));
        }
      },
      (error) => {
        dispatch(replacePaymentMethodFailed(error));
      },
    );
  };
};

export const replacingPaymentMethod = (): SubscribeTypes => ({
  type: REPLACING_PAYMENT_METHOD,
});

export const replacePaymentMethodSuccess = (replacePaymentMethodPlexoUrl: string): SubscribeTypes => ({
  type: REPLACE_PAYMENT_METHOD_SUCCESS,
  replacePaymentMethodPlexoUrl,
});

export const replacePaymentMethodFailed = (error: string): SubscribeTypes => ({
  type: REPLACE_PAYMENT_METHOD_ERROR,
  error,
});

export const executeForceSubscriptionPayment = (userId: string | undefined) => {
  return (dispatch: Dispatch<SubscribeTypes>) => {
    dispatch(forcingSubscriptionPayment());

    return forceSubscriptionPayment(userId).then(
      (response) => {
        dispatch(forceSubscriptionPaymentSuccess());
      },
      (error) => {
        dispatch(forceSubscriptionPaymentError(error));
      },
    );
  };
};

export const forcingSubscriptionPayment = (): SubscribeTypes => ({
  type: FORCING_SUBSCRIPTION_PAYMENT,
});

export const forceSubscriptionPaymentSuccess = (): SubscribeTypes => ({
  type: FORCE_SUBSCRIPTION_PAYMENT_SUCCESS,
});

export const forceSubscriptionPaymentError = (error: string): SubscribeTypes => ({
  type: FORCE_SUBSCRIPTION_PAYMENT_ERROR,
  error,
});
